// Keep the same positional IDs for drag/drop; arrange the full pitch in formation rows.
// Visual orientation: attacking up the pitch (GK near the bottom, strikers near the top).
// Horizontal spread uses the full lane map; the playing-field element is inset in CSS
// so wing tokens stay inside the pitch markings without squashing the formation.

const basePositionStyle = (position, slots) => {
  const has = slot => slots.includes(slot);
  const fourMidfielders = has('LM') && has('LCM') && has('RCM') && has('RM');
  // X as seen when attacking toward the top of the screen (LB left, RB right).
  const xPositions = {GK:50, RB:82, 'DC(R)':has('DC(C)')?68:61, 'DC(C)':50, 'DC(L)':has('DC(C)')?32:39, LB:18,
    'DM(R)':61,'DM(C)':50,'DM(L)':39, RM:82, RCM:fourMidfielders?61:68, CM:50, LCM:fourMidfielders?39:32, LM:18,
    RW:78, LW:22, RS:64, LS:36, CF:50, CAM:50};
  const x = xPositions[position] || 50;
  // Depth ranks from own goal (0) toward the opposition goal. Converted to screen % below.
  let depth=50;
  if(position==='GK') depth=10;
  else if(['RB','LB','DC(R)','DC(C)','DC(L)'].includes(position)) depth=30;
  else if(position.startsWith('DM')) depth=47;
  else if(['LM','RM','LCM','RCM'].includes(position)) depth=fourMidfielders?(has('DM(C)')?65:50):64;
  else if(position==='CM') depth=fourMidfielders?70:64;
  else if(position==='CAM') depth=70;
  else depth=88;
  return {'--pitch-depth':`${depth}%`,'--pitch-x':`${x}%`,position:'absolute',gridArea:'auto',left:`${x}%`,top:`${depth}%`,transform:'translate(-50%, -50%)',display:'flex'};
};

// Space the occupied formation lines equally, including formations with a DM or CAM line.
export const positionStyle = (position, slots) => {
  const style = basePositionStyle(position, slots);
  const lines = [...new Set(slots.map(slot => parseFloat(basePositionStyle(slot, slots).top)))].sort((a,b)=>a-b);
  const depth = 10 + lines.indexOf(parseFloat(style.top)) * 78 / Math.max(1, lines.length - 1);
  // Screen Y: own goal at the bottom (90%), attack toward the top (12%).
  const y = 100 - depth;
  return {...style, top:`${y}%`, '--pitch-y':`${y}%`, '--pitch-depth':`${depth}%`};
};

// Match compact-field.svg (~1.16) so the card grows taller, not wider.
export const PITCH_ASPECT = 1.18;
